import request from '@/utils/request';
// 获取备件
export const getPartsList = (params: any) =>
  request({
    url: 'Parts/partsList',
    method: 'GET',
    params
  });
// 不显示备件费用金额详情 和 备件可修改费用
export const setPartsSetting = (data: any) =>
  request({
    url: 'Parts/partsSet',
    method: 'POST',
    data
  });
// 添加备件
export const addParts = (data: any) =>
  request({
    url: 'Parts/parts',
    method: 'POST',
    data
  });

// 编辑备件
export const editParts = (data: any) =>
  request({
    url: 'Parts/parts',
    method: 'PUT',
    data
  });

// 删除备件
export const deleteParts = (data: any) =>
  request({
    url: 'Parts/parts',
    method: 'DELETE',
    data
  });
// 添加备件型号
export const addModel = (data: any) =>
  request({
    url: 'Parts/model',
    method: 'POST',
    data
  });
// 编辑备件型号
export const editModel = (data: any) =>
  request({
    url: 'Parts/model',
    method: 'PUT',
    data
  });

// 删除备件型号
export const deleteModel = (data: any) =>
  request({
    url: 'Parts/model',
    method: 'DELETE',
    data
  });

// 批量移动型号到指定名称（同步修改所属备件及对应库存型号）
export const moveModel = (data: any) =>
  request({
    url: 'Parts/batchMoveModel',
    method: 'PUT',
    data
  });
  // 获取备件属性
export const getAttributeList = (params: any) =>
  request({
    url: 'Parts/attributeList',
    method: 'GET',
    params
  });
// 添加备件属性
export const addAttribute = (data: any) =>
  request({
    url: 'Parts/attribute',
    method: 'POST',
    data
  });
// 修改备件属性
export const modifyAttribute = (data: any) =>
  request({
    url: 'Parts/attribute',
    method: 'PUT',
    data
  });
// 删除备件属性
export const delAttribute = (data: any) =>
  request({
    url: 'Parts/attribute',
    method: 'DELETE',
    data
  });
  // 设备导入
export const importParts = (data: any) =>
  request({
    url: 'Parts/importParts',
    method: 'POST',
    data
  });

// 新备件导入
export const importPartsNew = (data: any) =>
  request({
    url: 'Parts/importPartsNew',
    method: 'POST',
    data
  });

export const exportParts = (data: any) =>
  request({
    url: 'Parts/export',
    method: 'POST',
    data
  });

// 新备件导出
export const exportPartsNew = (data: any) =>
  request({
    url: 'Parts/exportNew',
    method: 'POST',
    data
  });
